import * as types from './mutations-types'

import services from '@/services'

import store from '@/store'

const updateSessionMessage = (state, message) => {
  services.session.updateSessionMessage(message)

  const messages = state.messages.filter(m => m.key !== message.key)

  messages.push(message)

  state.messages = messages
}

const concatMessages = (newChat, currentChat) => {
  const hasCurrentChat = currentChat && currentChat.messages
  const isSameChat = newChat && currentChat.key === newChat.key

  const shouldConcatMessages = hasCurrentChat && isSameChat

  if (shouldConcatMessages) {
    const remainingMessages = currentChat.messages.filter(
      currentMessage =>
        !newChat.messages.some(
          newMessage => newMessage.key === currentMessage.key
        )
    )

    const allMessages = [...remainingMessages, ...newChat.messages]

    allMessages.forEach(message => {
      services.session.updateSessionMessage(message)
    })

    newChat.messages = allMessages
  }
}

export default {
  [types.SET_CHAT](state, chat) {
    state.chat = chat

    state.ticket = chat.ticket

    state.message.attachments = []
  },
  [types.UPDATE_CHAT](state, chat) {
    state.ticket = chat.ticket

    concatMessages(chat, state.chat)

    state.chat = chat
  },
  [types.UPDATE_COMMENT](state, comment) {
    state.comment = comment
  },
  [types.UPDATE_COMMENT_ERROR_MAX_LENGTH](state, commentError) {
    state.commentError = commentError
  },
  [types.ADD_ATTACHMENT](state, attachment) {
    state.message.attachments.push(attachment)
  },
  [types.REMOVE_ATTACHMENT](state, attachment) {
    state.message.attachments = state.message.attachments.filter(
      a => a.url !== attachment.url
    )
  },
  [types.CLEAR_ATTACHMENTS](state) {
    state.message.attachments = []
  },
  [types.START_TYPING](state) {
    state.typing = true
  },
  [types.STOP_TYPING](state) {
    state.typing = false
  },
  [types.SCROLL_BOTTOM](state, value) {
    state.scrollBottom = value
  },
  [types.SET_READING_MESSAGES](state, value) {
    state.reading = value
  },
  [types.NEW_CONVERSATION](state) {
    store.state.forceDisconnect = false

    state.message = {
      attachments: []
    }

    state.messages = []

    state.ticket = undefined

    state.agent = undefined

    state.typing = false

    state.chat = undefined

    state.scrollBottom = false
  },
  [types.CREATE_MESSAGE](state, message) {
    services.session.updateSessionMessage(message)

    state.messages.push(message)
  },
  [types.SET_MESSAGES](state, messages) {
    state.messages = messages
  },
  [types.SET_MESSAGE_SENDING](state, message) {
    message.status = 'sending'

    updateSessionMessage(state, message)
  },
  [types.SET_MESSAGE_ERROR](state, message) {
    message.status = 'error'

    updateSessionMessage(state, message)
  },
  [types.SET_MESSAGE_SENDED](state, message) {
    message.status = 'sended'

    updateSessionMessage(state, message)
  },
  [types.SHOW_CLOSING_CHAT_LOADER](state, value) {
    state.chatClosingLoading = value
  },
  [types.SET_CREATING_CHAT](state, value) {
    state.creatingChat = value
  },
  [types.FOCUS_MESSAGE](state, msgKey) {
    state.focusedMessageKey = msgKey
  },
  [types.CLEAR_FOCUS_MESSAGE](state) {
    state.focusedMessageKey = undefined
  },
  [types.SET_EMOJI_PAGE_STATUS](state, value) {
    state.emojiPageStatus = value
  },
  [types.QUOTE_MESSAGE](state, message) {
    state.unsendedQuoteMessage = message
  },
  [types.CANCEL_QUOTE_MESSAGE](state) {
    state.unsendedQuoteMessage = undefined
  },
  [types.SET_SHOW_KB_CARD](state, show) {
    state.showKbCard = show
  },
  [types.SET_VOICE_RECORDING](state, recording) {
    state.voiceRecording = recording
  },
  [types.SET_FILE_DRAGGING](state, dragging) {
    state.dragging = dragging
  },
  [types.TOGGLE_NUMBER_INPUT](state) {
    state.showNumberInput = !state.showNumberInput
  },
  [types.SHOW_NUMBER_INPUT](state, show) {
    state.showNumberInput = show
  },
  [types.TOGGLE_DATE_PICKER](state) {
    state.showDatePicker = !state.showDatePicker
  },
  [types.SHOW_DATE_PICKER](state, show) {
    state.showDatePicker = show
  },
  [types.TOOGLE_DATE_PICKER_VALID](state, valid) {
    state.datePickerValid = valid
  },
  [types.SET_NUMBER_INPUT_VALID](state, valid) {
    state.numberInputValid = valid
  },
  [types.SET_UPLOAD_IN_PROCESS](state, hasUploadInProcess) {
    state.hasUploadInProcess = hasUploadInProcess
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
  }
}
